import React, { useState } from 'react';
import { Linkedin, Github, Mail, Phone, MapPin } from 'lucide-react';
import { contactData } from '../data/mock';
import PrivacyPolicyModal from './PrivacyPolicyModal';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isPrivacyOpen, setPrivacyOpen] = useState(false);

  const footerLinks = {
    servicios: [
      'Desarrollo Web',
      'Seguridad Informática',
      'VPS Cloud',
      'Hardware',
      'Automatización IA'
    ],
    empresa: [
      { name: 'Sobre Nosotros', href: '#about' },
      { name: 'Servicios', href: '#services' },
      { name: 'Equipo', href: '#team' },
      { name: 'Contacto', href: '#contacto' }
    ]
  };

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_bezalel-ux-update/artifacts/2jzt5ir3_LogoBitono.png"
              alt="Bezalel Technology"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Tu aliado estratégico en el mundo digital. Innovación tecnológica para tu éxito empresarial.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/bezalel-technology"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://github.com/bezalel-technology"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-colors"
              >
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Servicios</h3>
            <ul className="space-y-3">
              {footerLinks.servicios.map((servicio, index) => (
                <li key={index}>
                  <a
                    href="#services"
                    onClick={(e) => scrollToSection(e, '#services')}
                    className="text-gray-400 hover:text-cyan-400 transition-colors"
                  >
                    {servicio}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Empresa</h3>
            <ul className="space-y-3">
              {footerLinks.empresa.map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    onClick={(e) => scrollToSection(e, item.href)}
                    className="text-gray-400 hover:text-cyan-400 transition-colors"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <a
                  href={`mailto:${contactData.email}`}
                  className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
                >
                  {contactData.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <a
                  href={`tel:${contactData.phone}`}
                  className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
                >
                  {contactData.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  Arjona, Bolívar, Colombia
                </span>
              </li>
              <li className="flex items-start space-x-3 pt-2">
                <div className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clock"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
                </div>
                <div className="text-sm">
                  <p className="text-gray-300 font-medium">Horario de Atención:</p>
                  <p className="text-gray-400">Lunes a Viernes</p>
                  <p className="text-gray-400">8:00 a.m. - 5:00 p.m.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} BEZALEL TECHNOLOGY. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6 text-sm">
              <button
                onClick={() => setPrivacyOpen(true)}
                className="text-gray-400 hover:text-cyan-400 transition-colors"
              >
                Política de Privacidad
              </button>
              <button
                onClick={() => setPrivacyOpen(true)}
                className="text-gray-400 hover:text-cyan-400 transition-colors"
              >
                Términos de Servicio
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Float Button */}
      <a
        href={`https://wa.me/${contactData.whatsapp.replace(/\+/g, '')}?text=Hola%20Bezalel%20Technology%2C%20estoy%20interesado%20en%20sus%20soluciones%20tecnol%C3%B3gicas`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl hover:shadow-green-500/50 transition-all duration-300 z-50 group hover:scale-110"
        aria-label="Contactar por WhatsApp"
      >
        <svg
          className="w-8 h-8 text-white"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
        </svg>
      </a>

      <PrivacyPolicyModal
        isOpen={isPrivacyOpen}
        onClose={() => setPrivacyOpen(false)}
      />
    </footer>
  );
};

export default Footer;
